<mat-toolbar class="header">
    <a href="/plays?folderId=0">
        <img
            ngSrc="assets/tfs-logo-red-and-white.png"
            alt="Thermo Fisher Scientific logo"
            height="40"
            width="186"
            priority />
    </a>
    <span class="spacer"></span>
    <div id="division-picker">
        <button
            mat-button
            [matMenuTriggerFor]="divisionSwitch"
            aria-label="Switch Division"
            matTooltip="Switch Division"
            type="button">
            {{ selectedDivisionCode() }}
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #divisionSwitch="matMenu" xPosition="before" class="division-picker-menu">
            <button mat-menu-item (click)="switchDivision.emit()" type="button">Switch Division</button>
        </mat-menu>
    </div>
    <div id="page-menu">
        <button
            mat-icon-button
            [matMenuTriggerFor]="pagesMenu"
            aria-label="Select a Page"
            matTooltip="Select a Page"
            type="button">
            <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #pagesMenu="matMenu">
            @for (page of pagesWithPermissions(); track $index) {
                @if (page.url === 'login') {
                    <a mat-menu-item (click)="logOut.emit()" [routerLink]="[page.url]">
                        {{ page.name }}
                    </a>
                } @else {
                    <a
                        mat-menu-item
                        [routerLink]="[page.url]"
                        [queryParams]="{ folderId: page?.rootFolderId }"
                        [disabled]="!page.allowed">
                        {{ page.name }}
                    </a>
                }
            }
        </mat-menu>
    </div>
</mat-toolbar>
